/**
 * @Author: v_jppjpeng
 * @Date: 2022-09-23 13:17:28
 * @Explain: 邮件移动模板
 */
import http from '../http';

const MODEL = '/mailTemplateGroup';

export default {
  // 列表
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // 添加
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/add`, data);
  },
  // 编辑
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/update`, data);
  },
  // 删除
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data);
  },
};
